// extracted by mini-css-extract-plugin
export default {"Title":"BillingDetails_Title__Lm-JG","FormTitle":"BillingDetails_FormTitle__Mem5q"};